import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { vovSharedService } from 'src/app/shared/services/vov-shared.service';
import { CodeEnforcementService } from '../../code-enforcement.service';
import * as moment from 'moment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';



@Component({
  selector: 'app-create-case',
  templateUrl: './create-case.component.html',
  styleUrls: ['./create-case.component.scss']
})
export class CreateCaseComponent implements OnInit {
  createCaseForm: FormGroup;
  public streets: any;
  public violations: any;
  public days: any;
  public otherReasonForViolation: any;
  public otherReasonForDays: any;
  public otherReasonForCategories: any;
  public categories: any;
  public currentUserId: any;
  public violationAlreasyExists: boolean = false;
  public daysToCureAlreasyExists: boolean = false;
  public categoryAlreasyExists: boolean = false;
  public formDialog: MatDialogRef<any> = null;
  public confirmDialog: MatDialogRef<any> = null;
  public popupOpend: boolean = false;
  public btnDisabled: boolean = false;
  @ViewChild('confirmRef') confirmRef: TemplateRef<any>;
  constructor(private formBuilder: FormBuilder,
    private codeEnforcementService: CodeEnforcementService,
    private vovSharedService: vovSharedService,
    private _snackBar: MatSnackBar,
    private router: Router,
    public dialog: MatDialog) {

    //   history.pushState(null, null, location.href);
    // window.onpopstate = function () {
    //   history.go(1);
    // }
  }

  ngOnInit(): void {
    this.createCaseForm = this.formBuilder.group({
      violationId: ['', Validators.required],
      daysToCureId: ['', Validators.required],
      categoryId: ['', Validators.required],
      otherReasonForViolation: [''],
      otherReasonForDays: ['', [Validators.pattern(/^(?=.*\S).+$/), Validators.min(1)]],
      otherReasonForCategories: [''],
      streetId: ['', Validators.required],
      streetNumber: ['', Validators.required]
    });

    this.codeEnforcementService.fetchAllViolations().subscribe((violationRes) => {
      let nootherReasonForViolation = [];
      this.violations = violationRes.violationsList;
      this.otherReasonForViolation = this.violations.filter(s => s.violation == 'Other')
      // this.streets.sort((a, b) => a.street.localeCompare(b.street));
      nootherReasonForViolation = this.violations.filter(s => s.violation != 'Other');
      nootherReasonForViolation.sort((a, b) => a.violation.localeCompare(b.violation));
      nootherReasonForViolation.push(this.otherReasonForViolation[0]);
      this.violations = nootherReasonForViolation;
    });

    this.codeEnforcementService.fetchAllDaysToCure().subscribe((daysRes) => {
      let cusArr = [];
      this.days = daysRes.DaysToCureList;
      this.otherReasonForDays = this.days.filter(s => s.numberOfDays == 'Other')
      const noOtherReasonForDays = this.days.filter(s => s.numberOfDays != 'Other')
      cusArr = noOtherReasonForDays.sort((a, b) => {
        return a.numberOfDays - b.numberOfDays;
      });
      cusArr.push(this.otherReasonForDays[0]);
      this.days = cusArr;
    });

    this.codeEnforcementService.fetchAllCategories().subscribe((categoryRes) => {
      let noOtherReasonForCategories = [];
      this.categories = categoryRes.categoryList;
      this.otherReasonForCategories = this.categories.filter(s => s.category == 'Other')
      noOtherReasonForCategories = this.categories.filter(s => s.category != 'Other');
      noOtherReasonForCategories = noOtherReasonForCategories.sort((a, b) => a.category.localeCompare(b.category)).filter(cat => cat.category != 'Resolved')
      noOtherReasonForCategories.push(this.otherReasonForCategories[0]);
      this.categories = noOtherReasonForCategories;
    });


    this.vovSharedService.fetchAllStreets().subscribe((res) => {
      this.streets = res.streetsList;
      this.streets.sort((a, b) => a.street.localeCompare(b.street));
    });

    const currentUser = localStorage.getItem("currentUser");
    this.currentUserId = JSON.parse(currentUser).id;

    this.createCaseForm.controls['violationId'].valueChanges.subscribe(
      (value) => {
        if (value == this.otherReasonForViolation[0].id) {
          this.createCaseForm.controls['otherReasonForViolation'].setValidators([Validators.required]);
        } else {
          this.createCaseForm.controls['otherReasonForViolation'].setValue(null);
          this.createCaseForm.controls['otherReasonForViolation'].setValidators([]);
          this.createCaseForm.controls['otherReasonForViolation'].updateValueAndValidity();
        }
        this.createCaseForm.controls['otherReasonForViolation'].updateValueAndValidity();
      }
    );


    this.createCaseForm.controls['daysToCureId'].valueChanges.subscribe(
      (value) => {
        if (value == this.otherReasonForDays[0].id) {
          this.createCaseForm.controls['otherReasonForDays'].setValidators([Validators.required]);
        } else {
          this.createCaseForm.controls['otherReasonForDays'].setValue('');
          this.createCaseForm.controls['otherReasonForDays'].setValidators([]);
          this.createCaseForm.controls['otherReasonForDays'].updateValueAndValidity();
        }
        this.createCaseForm.controls['otherReasonForDays'].updateValueAndValidity();
      }
    );

    this.createCaseForm.controls['categoryId'].valueChanges.subscribe(
      (value) => {
        if (value == this.otherReasonForCategories[0].id) {
          this.createCaseForm.controls['otherReasonForCategories'].setValidators([Validators.required]);
        } else {
          this.createCaseForm.controls['otherReasonForCategories'].setValue('');
          this.createCaseForm.controls['otherReasonForCategories'].setValidators([]);
          this.createCaseForm.controls['otherReasonForCategories'].updateValueAndValidity();
        }
        this.createCaseForm.controls['otherReasonForCategories'].updateValueAndValidity();
      }
    );


    this.createCaseForm.controls['otherReasonForDays'].valueChanges.subscribe(
      (value) => {
        if (value != "" || value != null) {
          const days = this.days.filter(s => s.numberOfDays == value);
          if (days.length) {
            this.daysToCureAlreasyExists = true;
          } else {
            this.daysToCureAlreasyExists = false;
          }
        } else {
          this.daysToCureAlreasyExists = false;
        }
      }
    );

    this.createCaseForm.controls['otherReasonForCategories'].valueChanges.subscribe(
      (value) => {
        if (value != "" || value != null) {
          const cateExist = this.categories.filter(s => s.category.toUpperCase() == value.toUpperCase());
          if (cateExist.length) {
            this.categoryAlreasyExists = true;
          } else {
            this.categoryAlreasyExists = false;
          }
        } else {
          this.categoryAlreasyExists = false;
        }
      }
    );

    this.createCaseForm.controls['otherReasonForViolation'].valueChanges.subscribe(
      (value) => {
        if (value != "" || value != null) {
          const violationExists = this.violations.filter(s => s.violation.toUpperCase() == value.toUpperCase());
          if (violationExists.length) {
            this.violationAlreasyExists = true;
          } else {
            this.violationAlreasyExists = false;
          }
        } else {
          this.violationAlreasyExists = false;
        }
      }
    );
  }
  onSubmit(alreadyExists?) {
    this.btnDisabled = true;
    this.createCaseForm.value['userId'] = this.currentUserId;
    this.createCaseForm.value['alreadyExists'] = alreadyExists;
    this.codeEnforcementService.createCase(this.createCaseForm.value).subscribe((res) => {
      if (res.message) {
        if (res.message == 'Case already exists with same details') {
          // this._snackBar.open('Warning :' + res.message, '', {
          //   duration: 3000,
          //   horizontalPosition: 'right',
          //   panelClass: 'warning-snackbar'
          // });
          //return
          this.confirmDialog = this.dialog.open(this.confirmRef, {
            width: '600px',
            data: 'data'
          });
          this.confirmDialog.disableClose = true;
          this.popupOpend = true;
        } else {
          this._snackBar.open('Success :' + res.message, '', {
            duration: 3000,
            horizontalPosition: 'right',
            panelClass: 'success-snackbar'
          });
          this.confirmDialog ? this.confirmDialog.close() : null;
          this.popupOpend = false;
          this.router.navigate(['/case-listing']);
        }
      }
    }, error => {
      let errorMessage = error.error.message ? error.error.message : error;
      this._snackBar.open('Error :' + errorMessage, '', {
        duration: 3000,
        horizontalPosition: 'right',
        panelClass: 'error-snackbar'
      });
    });
  }
  reset() {
    this.createCaseForm.reset();
    this.daysToCureAlreasyExists = false;
    this.categoryAlreasyExists = false;
    this.violationAlreasyExists = false;
  }

  onNoClick() {
    this.confirmDialog.close();
    this.popupOpend = false;
    this.btnDisabled = false;
  }

  confirm() {
    const alreadyExists = true;
    this.onSubmit(alreadyExists)
  }
}
